import Vue from 'vue'
import AvatarCropper from "vue-avatar-cropper"

Vue.use(AvatarCropper);
